import React from 'react';
import {Route, Switch} from "react-router-dom";
import "../../desktop.css";
import Footer from "../../../shared/MiniCenteredFooter";
import Header from "../../../shared/SiteHeader";
import AboutUs from "../../../shared/AboutUs";
import VersusPage from "../../../shared/VersusPage";
import ResearchPage from "../../../shared/ResearchPage";
import tw from "twin.macro";
import Home from "./Home";

const Page = tw.div`min-h-screen w-full relative flex flex-col`;
const Container = tw.div`flex-grow`;

function TeamApp() {
    return (
        <Switch>
            <Route exact path="/">
                <Home />
            </Route>
            <Route path="/versus/:slug">
                <Page>
                    <Header/>
                    <Container>
                        <VersusPage/>
                    </Container>
                    <Footer/>
                </Page>
            </Route>
            <Route path="/research">
                <Page>
                    <Header/>
                    <Container>
                        <ResearchPage/>
                    </Container>
                    <Footer/>
                </Page>
            </Route>
            <Route path="/aboutus">
                <Page>
                    <Header/>
                    <Container>
                        <AboutUs/>
                    </Container>
                    <Footer/>
                </Page>
            </Route>
        </Switch>
    );
}

export default TeamApp;